import { Sparkles, Flame, Trophy, HeartPulse } from "lucide-react";
import { Reveal, SectionTag } from "@/components/doodles";

const CARDS = [
  {
    icon: Sparkles,
    color: "bg-pink text-cream",
    title: "JUST STARTING OUT",
    copy: "Never touched a barbell? Perfect — neither had any of us, once. We start slow, smart, and exactly where you are.",
    tag: "beginners",
  },
  {
    icon: Flame,
    color: "bg-gold",
    title: "LOSE WEIGHT & BUILD HABITS",
    copy: "No crash plans, no punishment cardio. Small habits, stacked every week, that actually stick around.",
    tag: "habit builders",
  },
  {
    icon: Trophy,
    color: "bg-electric",
    title: "LEVEL UP PERFORMANCE",
    copy: "Strength, conditioning, and programming that turns 'decent' into 'qualified'. Athletes: let's chase PRs.",
    tag: "athletes",
  },
  {
    icon: HeartPulse,
    color: "bg-lime",
    title: "REBUILD AFTER INJURY",
    copy: "I took a year off and came back stronger. Your comeback gets the same patience, plan, and push.",
    tag: "comebacks",
  },
];

export const WhoIHelp = () => (
  <section id="who-i-help" className="py-24 sm:py-32 bg-offwhite border-y-[3px] border-ink relative">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <Reveal><SectionTag className="text-royal">WHO I HELP</SectionTag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 leading-[0.95]">
              YOU BELONG <span className="hl-pink">HERE</span>.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="font-hand text-2xl sm:text-3xl text-pink -rotate-2">yes, you. no gatekeeping here ↓</p>
        </Reveal>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} className="h-full">
            <div
              className={`card-pop h-full bg-white p-6 ${i % 2 ? "rotate-1" : "-rotate-1"} hover:rotate-0 transition-transform`}
              data-testid={`who-card-${i + 1}`}
            >
              <div className={`w-12 h-12 border-[3px] border-ink flex items-center justify-center shadow-[3px_3px_0_#0d0d0d] ${c.color}`}>
                <c.icon className="w-6 h-6" />
              </div>
              <p className="font-bebas text-sm tracking-[0.3em] text-ink/50 mt-5">0{i + 1}</p>
              <h3 className="font-display font-extrabold uppercase text-xl mt-1 leading-tight">{c.title}</h3>
              <p className="mt-3 text-sm font-semibold text-ink/70 leading-relaxed">{c.copy}</p>
              <p className="font-hand text-xl text-pink mt-4">→ {c.tag}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
